import React from 'react'

import { getPreviousButtonStyle, getNextButtonStyle } from './helpers'
import MonthButton from './MonthButton'
import MonthTitle from './MonthTitle'
import YearButton from './YearButton'

import type { CustomHeaderProps } from './types'

export const CustomHeader: React.FC<CustomHeaderProps> = ({
  customHeaderCount,
  monthDate,
  decreaseMonth,
  increaseMonth,
  decreaseYear,
  increaseYear,
  monthsShown,
}) => {
  const previousButtonStyle = getPreviousButtonStyle(customHeaderCount)
  const nextButtonStyle = getNextButtonStyle(
    monthsShown === 1 ? 1 : customHeaderCount
  )

  return (
    <div className="react-datepicker__header-title">
      <YearButton
        onClick={decreaseYear}
        style={previousButtonStyle}
        type="previous"
      />
      <MonthButton
        onClick={decreaseMonth}
        style={previousButtonStyle}
        type="previous"
      />
      <MonthTitle monthDate={monthDate} />
      <MonthButton
        onClick={increaseMonth}
        style={nextButtonStyle}
        type="next"
      />
      <YearButton onClick={increaseYear} style={nextButtonStyle} type="next" />
    </div>
  )
}
